import React, { useMemo } from 'react';

import { CandidateDetailsAction } from '@constants';
import {
  IAvailableCandidatesViewState,
  useCollapsedGroups,
  useIsPhone,
} from '@hooks';
import { IAvailableCandidate } from '@types';
import { sortAvailableCandidates } from '@utils';
import { CandidateCardList } from 'components/candidate/CandidatesList/components/CandidateCardList';
import { AvailableCandidateCard } from './AvailableCandidateCard';
import { AvailableCandidatesTable } from './AvailableCandidatesTable';

interface IAvailableCandidatesListProps {
  candidates: IAvailableCandidate[];
  view: IAvailableCandidatesViewState;
  emptyState: React.ReactNode;
  onSort: (key: string) => void;
  onCandidateClick: (id: string) => void;
  onAction: (candidateId: string, action: CandidateDetailsAction) => void;
  onLearnMore: (candidateId: string) => void;
  onOpenResume: (candidateId: string) => void;
}

export const AvailableCandidatesList: React.FC<
  IAvailableCandidatesListProps
> = ({
  candidates,
  view,
  emptyState,
  onSort,
  onCandidateClick,
  ...handlers
}) => {
  const isPhone = useIsPhone();
  const fold = useCollapsedGroups(Boolean(view.query.trim()));

  const groups = useMemo(
    () => [
      {
        id: '',
        name: '',
        candidates: sortAvailableCandidates(candidates, view.sort),
      },
    ],
    [candidates, view.sort],
  );

  if (!candidates.length) return <>{emptyState}</>;

  return isPhone ? (
    <CandidateCardList
      groups={groups}
      renderCard={(candidate) => (
        <AvailableCandidateCard
          candidate={candidate}
          onClick={() => onCandidateClick(candidate.id)}
          {...handlers}
        />
      )}
      fold={fold}
    />
  ) : (
    <AvailableCandidatesTable
      groups={groups}
      view={view}
      onSort={onSort}
      onCandidateClick={onCandidateClick}
      {...handlers}
    />
  );
};
